module.exports = __webpack_public_path__ + "img/0e6fd76.jpg";